class ManualPredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.searchTerm = "";
    this.searchButton = this.querySelector(".search__button");
    this.form = this.querySelector("form");

    this.setupEventListeners();
  }

  setupEventListeners() {
    // Handle form submission - let it proceed normally to the search page
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));

    // Handle search button click
    this.searchButton.addEventListener(
      "click",
      this.onSearchButtonClick.bind(this)
    );

    // Handle keyboard input
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }

  onSearchButtonClick(event) {
    // Allow normal form submission to redirect to search page
    const searchTerm = this.getQuery();
    if (searchTerm.length === 0) {
      event.preventDefault(); // Only prevent submission if search is empty
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    // We're just tracking the search term for potential use
    super.onChange();
    this.searchTerm = this.getQuery();
  }

  onFormSubmit(event) {
    // Allow normal form submission to redirect to search page
    const searchTerm = this.getQuery();
    if (searchTerm.length === 0) {
      event.preventDefault(); // Only prevent submission if search is empty
    }
  }

  onKeydown(event) {
    // Handle escape key to close the search dropdown
    if (event.key === "Escape") {
      // Find and close the search dropdown
      const searchDropdown = document.getElementById("search-dropdown");
      if (searchDropdown) {
        searchDropdown.classList.remove("active");
        document
          .getElementById("search-toggle")
          ?.setAttribute("aria-expanded", "false");
      }

      // Clear input
      this.input.value = "";
    }
  }
}

customElements.define("manual-predictive-search", ManualPredictiveSearch);
